import { service } from '../../../../helpers/http'

// Lista plana paginada da grade. Sem parâmetro de rota: tudo vai na query string
// (page/per_page/search/filters/base_filters). filters e base_filters são JSON.
export const ActionGetItems = ({ dispatch }, payload) => {

    const query = {}
    if (payload.page != null) query.page = payload.page
    if (payload.per_page != null) query.per_page = payload.per_page
    if (payload.search) query.search = payload.search
    if (payload.filters && Object.keys(payload.filters).length) {
        query.filters = JSON.stringify(payload.filters)
    }
    if (payload.base_filters && Object.keys(payload.base_filters).length) {
        query.base_filters = JSON.stringify(payload.base_filters)
    }
    // Só as colunas VISÍVEIS: o backend traz no SELECT/eager-load apenas essas.
    if (Array.isArray(payload.columns) && payload.columns.length) {
        query.columns = JSON.stringify(payload.columns)
    }

    return service({
        module: 'domainCatalogGrid',
        action: 'getItems',
        params: query
    })
}

// Total + subtotal (agregado cacheado) do conjunto filtrado. Chamado em paralelo
// à lista — não bloqueia o render da página.
export const ActionGetSummary = ({ dispatch }, payload) => {

    const query = {}
    if (payload.per_page != null) query.per_page = payload.per_page
    if (payload.search) query.search = payload.search
    if (payload.filters && Object.keys(payload.filters).length) {
        query.filters = JSON.stringify(payload.filters)
    }

    return service({
        module: 'domainCatalogGrid',
        action: 'getSummary',
        params: query
    })
}

// Valores distintos de uma coluna para o checklist do AutoFiltro.
export const ActionGetItemsDistinct = ({ dispatch }, payload) => {

    const query = { column: payload.column }
    if (payload.search) query.search = payload.search
    if (payload.term) query.term = payload.term
    if (payload.filters && Object.keys(payload.filters).length) {
        query.filters = JSON.stringify(payload.filters)
    }
    // Filtro-base "apenas ofertáveis" enviado à parte (sempre aplicado no backend).
    if (payload.baseFilters && Object.keys(payload.baseFilters).length) {
        query.base_filters = JSON.stringify(payload.baseFilters)
    }

    return service({
        module: 'domainCatalogGrid',
        action: 'getItemsDistinct',
        params: query
    })
}

// Edição de uma célula/linha: grava direto em offer_items. {id} preenche a rota;
// o campo alterado vai no corpo.
export const ActionPutItem = ({ dispatch }, payload) => {

    const { id, ...body } = payload

    return service({
        module: 'domainCatalogGrid',
        action: 'putItem',
        params: { id },
        payload: body
    })
}

// Edição em massa de uma coluna (aplicar/limpar) nas linhas selecionadas ou em
// todos do filtro atual. A rota não tem parâmetro: params:{} (objeto truthy) força
// o helper a enviar o payload no CORPO do PUT (e não como query string).
export const ActionBulkUpdateItems = ({ dispatch }, payload) => {

    return service({
        module: 'domainCatalogGrid',
        action: 'bulkUpdateItems',
        params: {},
        payload: payload
    })
}

// Preferências do usuário (colunas visíveis + filtros) — persistidas no banco.
export const ActionGetPreferences = ({ dispatch }) => {
    return service({
        module: 'domainCatalogGrid',
        action: 'getPreferences',
        params: {}
    })
}

// Salva as preferências. params:{} (truthy) força o corpo no PUT.
export const ActionSavePreferences = ({ dispatch }, payload) => {
    return service({
        module: 'domainCatalogGrid',
        action: 'savePreferences',
        params: {},
        payload: payload
    })
}

// Painel de Indicadores de Oferta — indicador "CHOQUE DE HORÁRIO na turma
// composição" (real, lido de offer_items).
export const ActionGetIndicatorScheduleClash = ({ dispatch }) => {
    return service({
        module: 'domainCatalogGrid',
        action: 'getIndicatorScheduleClash',
        params: {}
    })
}

// Painel de Indicadores de Oferta — indicador "MODULARIZAÇÃO ERRADA" (real,
// lido de offer_items).
export const ActionGetIndicatorModularizationMismatch = ({ dispatch }) => {
    return service({
        module: 'domainCatalogGrid',
        action: 'getIndicatorModularizationMismatch',
        params: {}
    })
}

// Painel de Indicadores de Oferta — indicador "Junção Mista (Mandala × Radial)"
// (real, lido de offer_items).
export const ActionGetIndicatorMixedJoin = ({ dispatch }) => {
    return service({
        module: 'domainCatalogGrid',
        action: 'getIndicatorMixedJoin',
        params: {}
    })
}

// Painel de Indicadores de Oferta — indicador "Composições (Percurso) ATIVA sem
// Oferta" (real, lido de offer_items + work_time_base_group_statuses).
export const ActionGetIndicatorActiveWithoutOffer = ({ dispatch }) => {
    return service({
        module: 'domainCatalogGrid',
        action: 'getIndicatorActiveWithoutOffer',
        params: {}
    })
}

// Painel de Indicadores de Oferta — indicador "Oferta indicada para ser
// OFERTADA, porém com percurso já CURSADO ou DISPENSADO" (real, lido de offer_items).
export const ActionGetIndicatorEquivalentAlreadyOffered = ({ dispatch }) => {
    return service({
        module: 'domainCatalogGrid',
        action: 'getIndicatorEquivalentAlreadyOffered',
        params: {}
    })
}

// Painel de Indicadores de Oferta — indicador "Composições (Percurso) com
// MATRIZES DIFERENTES" (real, lido de offer_items).
export const ActionGetIndicatorDifferentCurriculum = ({ dispatch }) => {
    return service({
        module: 'domainCatalogGrid',
        action: 'getIndicatorDifferentCurriculum',
        params: {}
    })
}

// Painel de Indicadores de Oferta — indicador "Composições (Percurso) de
// FORMANDOS (Último Semestre) com UC PENDENTES no Percurso" (real, lido de offer_items).
export const ActionGetIndicatorGraduatingPendingDiscipline = ({ dispatch }) => {
    return service({
        module: 'domainCatalogGrid',
        action: 'getIndicatorGraduatingPendingDiscipline',
        params: {}
    })
}

// Painel de Indicadores de Oferta — indicador "Ofertas SEM MODALIDADE
// definida" (real, lido de offer_items).
export const ActionGetIndicatorMissingModality = ({ dispatch }) => {
    return service({
        module: 'domainCatalogGrid',
        action: 'getIndicatorMissingModality',
        params: {}
    })
}

// Painel de Indicadores de Oferta — indicador "Oferta sem DIA DA SEMANA
// definido" (real, lido de offer_items).
export const ActionGetIndicatorMissingDay = ({ dispatch }) => {
    return service({
        module: 'domainCatalogGrid',
        action: 'getIndicatorMissingDay',
        params: {}
    })
}

// Painel de Indicadores de Oferta — indicador "MESMA OFERTA proposta em DOIS
// COMBOS DE DIAS DIFERENTES" (real, lido de offer_items).
export const ActionGetIndicatorSameOfferDifferentDayCombo = ({ dispatch }) => {
    return service({
        module: 'domainCatalogGrid',
        action: 'getIndicatorSameOfferDifferentDayCombo',
        params: {}
    })
}

// Painel de Indicadores de Oferta — indicador "MESMA OFERTA proposta em DUAS
// MODALIDADES DE OFERTA REGRA DIFERENTES" (real, lido de offer_items).
export const ActionGetIndicatorSameOfferDifferentModality = ({ dispatch }) => {
    return service({
        module: 'domainCatalogGrid',
        action: 'getIndicatorSameOfferDifferentModality',
        params: {}
    })
}

// Painel de Indicadores de Oferta — histórico semanal (rodadas de
// segunda-feira) das contagens dos indicadores, por período letivo.
export const ActionGetIndicatorsEvolution = ({ dispatch }) => {
    return service({
        module: 'domainCatalogGrid',
        action: 'getIndicatorsEvolution',
        params: {}
    })
}
